import { KnmSearchActionsEnum } from '../enums/KnmSearchActionsEnum';
import { IKnmSearchState } from '../interfaces/IKnmSearchState';
import { KnmSearchAction } from '../types/KnmSearchAction';

const initial: IKnmSearchState = {
  knms: [],
  page: 1,
  pageCount: 0,
  totalCount: 0,
  order: '',
  filter: {},
};

export function knmSearchReducer(state = initial, action: KnmSearchAction) {
  switch (action.type) {
    case KnmSearchActionsEnum.KNM_SEARCH_RESET_PAGE: {
      return initial;
    }
    case KnmSearchActionsEnum.KNM_SEARCH_SET_DATA: {
      const { knms, page, pageCount, totalCount } = action.payload;
      const newState: IKnmSearchState = {
        ...state,
        knms,
        page,
        pageCount,
        totalCount,
      };

      return newState;
    }
    case KnmSearchActionsEnum.KNM_SEARCH_SET_ORDER: {
      const newState: IKnmSearchState = {
        ...state,
        order: action.payload.order,
      };

      return newState;
    }
    case KnmSearchActionsEnum.KNM_SEARCH_SET_KNM_SUPERVISION_TYPES_OPTIONS_ALL: {
      const { knmSupervisionTypesOptionsAll } = action.payload;
      const newState: IKnmSearchState = {
        ...state,
        knmSupervisionTypesOptionsAll,
      };

      return newState;
    }
    case KnmSearchActionsEnum.KNM_SEARCH_SET_KNM_SUPERVISION_TYPES_ERVK_OPTIONS_ALL: {
      const { knmSupervisionTypesErvkOptionsAll } = action.payload;

      const newState: IKnmSearchState = {
        ...state,
        knmSupervisionTypesErvkOptionsAll,
      };

      return newState;
    }
    case KnmSearchActionsEnum.KNM_SEARCH_SET_FILTER: {
      const newState: IKnmSearchState = {
        ...state,
        filter: action.payload.filter,
      };

      return newState;
    }
    case KnmSearchActionsEnum.KNM_SEARCH_SET_SEARCH_STRING: {
      const newState: IKnmSearchState = {
        ...state,
        searchString: action.payload.searchString,
      };

      return newState;
    }
    default:
      return state;
  }
}
